export const determineCreditRating = (buyerCreditScoreSummary?: string): 'Good' | 'Bad' | 'N/A' => {
  if (!buyerCreditScoreSummary) return 'N/A';
  
  const scoreMatch = buyerCreditScoreSummary.match(/\d+/);
  if (scoreMatch) {
    const score = parseInt(scoreMatch[0]);
    return score >= 650 ? 'Good' : 'Bad';
  }
  
  // Check for text-based descriptions
  const lowerSummary = buyerCreditScoreSummary.toLowerCase();
  if (lowerSummary.includes('below') && lowerSummary.includes('550')) {
    return 'Bad';
  } else if (lowerSummary.includes('good') || lowerSummary.includes('excellent')) {
    return 'Good';
  }
  
  return 'N/A';
};